import React, { forwardRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CheckOutlineIcon from 'mdi-react/CheckOutlineIcon';

const Notification = forwardRef(({
  title = null,
  type = 'info',
  message = null,
  customClassName = '',
  timeOut = 5000,
  onClick,
  onRequestHide,
}, ref) => {
  const requestHide = useCallback(() => {
    if (onRequestHide) {
      onRequestHide();
    }
  }, [onRequestHide]);

  useEffect(() => {
    let timer = null;
    if (timeOut !== 0) {
      timer = setTimeout(requestHide, timeOut);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timeOut, requestHide]);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    requestHide();
  };

  const className = classnames([
    'notification',
    `notification-${type}`,
    customClassName,
  ]);
  const titleHtml = title ? <h4 className="title">{title}</h4> : null;
  return (
    <div className={className} onClick={() => handleClick()} ref={ref}>
      <div className="notification-message" role="alert">
        {titleHtml}
        <div className="message">
          { type === 'success' && <CheckOutlineIcon size={25} className="mr-2 align-middle"/>}
          <span className="align-middle">{message}</span>
        </div>
      </div>
    </div>
  );
});

Notification.displayName = 'Notification';

Notification.propTypes = {
  type: PropTypes.oneOf([
    'info',
    'success',
    'warning',
    'error',
    'primary',
    'secondary',
  ]),
  title: PropTypes.node,
  message: PropTypes.node,
  timeOut: PropTypes.number,
  onClick: PropTypes.func,
  onRequestHide: PropTypes.func,
  customClassName: PropTypes.string,
};

export default Notification;
